import { Component, Inject, ViewChild } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogState,
} from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BuildingTypeModel } from '../../../core/models/classes/building';
import { BuildingtypeService } from '../../../core/services/building-type.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SelectionModel } from '@angular/cdk/collections';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { BuildingColorsComponent } from '../buildingcolors/buildingcolors.component';
import { DataoptionsService } from '../../../core/services/data-options.service';

@Component({
  selector: 'app-rackcache',
  templateUrl: './rackcache.component.html',
  styleUrls: ['./rackcache.component.scss'],
})

export class RackCacheComponent {
  displayedColumns: string[] = ['select', 'name'];
  dataSource;
  filteredList: Array<BuildingTypeModel> = [];
  buildingTypes: BuildingTypeModel[] = [];
  buildingStyles: BuildingTypeModel[] = [];
  selectionModel = new SelectionModel<BuildingTypeModel>(true, []);
  selectedBuilding: BuildingTypeModel;
  chosenBuildings: Array<BuildingTypeModel> = [];
  prevChangedBuildings: Array<BuildingTypeModel> = [];

  @ViewChild(MatSort) sort: MatSort;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private buildingtypeService: BuildingtypeService,
    private dataOptionService: DataoptionsService,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<BuildingColorsComponent>
  ) {
    this.dataSource = new MatTableDataSource([]);
  }

  ngAfterViewInit(): void {}

  ngOnInit(): void {
    if (this.buildingStyles.length !== 0) {
      this.buildingStyles.splice(0);
    }
    this.fetchAllBuildingTypes();  
  }

  fetchAllBuildingTypes(){
    this.buildingtypeService.getBuildingTypes().subscribe({
      next: (s) => {
        this.buildingStyles = s;
        this.rackCaching();        
        this.dataSource.data = this.buildingStyles.sort((a, b) =>
          a.name > b.name ? 1 : -1
        );
        this.dataSource.sort = this.sort;
      },
    });
  }

  rackCaching(){
    this.dataOptionService.getRackCahcingOptions().subscribe({
      next: (data) => {
        if (data !== null) {
          for (let item of data) {
            var bk = this.buildingStyles.find((e) => e.name === item);
            if (bk !== undefined) {
              this.chosenBuildings.push(bk);
              this.selectionModel.select(bk);
            }
          }
        }
      },
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    if (this.filteredList.length === 0) {
      //no item in filtered list
      const numSelected = this.selectionModel.selected.length;
      const numRows = this.dataSource.data.length;
      return numSelected === numRows;
    } //items available in filtered list
    else {
      const numSelected = this.selectionModel.selected.length;
      const numRows = this.filteredList.length;
      return numSelected === numRows;
    }
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected() === false) {
      var filteredListEmpty = this.filteredList.length === 0 ? true : false;
      if (filteredListEmpty) {
        this.dataSource.data.forEach((row) => this.selectionModel.select(row));
        this.chosenBuildings = this.dataSource.data;
      } else {
        this.filteredList.forEach((row) => this.selectionModel.select(row));
        this.chosenBuildings = this.filteredList;
      }
    } else {
      this.selectionModel.clear();
      this.chosenBuildings = [];
    }
  }

  buildingFilter(event: Event) {
    this.dataSource.filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
    this.filteredList = this.dataSource.data.filter((item) =>
      item.name.toLowerCase().includes(this.dataSource.filter)
    );
  }

  add(row: BuildingTypeModel, value: MatCheckboxChange) {
    if (value.checked === true) {
      this.chosenBuildings.push(row);
    } else {
      if (this.dialogRef.getState() === MatDialogState.OPEN) {
        this.prevChangedBuildings.push(row);
        var idx = this.chosenBuildings.indexOf(row);
        if (idx !== -1) {
          this.chosenBuildings.splice(idx, 1);
        }
      }
    }
  }

  onSave(): void {    
    this.prevChangedBuildings = [];
    this.dataOptionService
      .saveRackCachingOptions(
        this.chosenBuildings.map(function (building) {
          return building.name;
        })
      )
      .subscribe({
        next: (data) => {
          if (data.status == 200) {
            this.dialogRef.close();
          }
        },
      });
  }
}